module.exports = __webpack_public_path__ + "img/icon-healthprog-inactive.5ffac9ea.png";